import { makeAutoObservable, runInAction } from "mobx";
import { apiGet } from "../utils/fetch";
import type { UserRoleInterface, GenericResponseInterface } from "../interfaces/interfaces";

class UserRoleStore {
  userRoles: UserRoleInterface[] = [];
  loading = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async loadUserRoles() {
    this.loading = true;
    this.error = null;
    try {
      const result = await apiGet<GenericResponseInterface<UserRoleInterface[]>>('/userRoles');
      runInAction(() => {
        if (result.status && result.data) {
          this.userRoles = result.data;
        } else {
          this.error = result.message || 'Failed to fetch user roles';
        }
        this.loading = false;
      });
    } catch (err: any) {
      runInAction(() => {
        this.error = err.message || 'Failed to fetch user roles';
        this.loading = false;
      });
    }
  }
}

const userRoleStore = new UserRoleStore();
export default userRoleStore;